/**
 * Created by Reda on 17.08.2026
 */

CustomerRecipes.autumn26 = cleverapps.clone(CustomerRecipes.universal, true);

CustomerRecipes.autumn26.rpcustomerbridge0_0[0].ingredients[0].type = undefined;
CustomerRecipes.autumn26.rpcustomerbridge0_0[0].ingredients[0].code = "expwood";

Ruins.TIERS.autumn26 = cleverapps.clone(Ruins.TIERS.universal, true);

MissionTree.PRIZES.autumn26 = [];

AchievementsConfig.registerExpedition("autumn26", {
    fog: "fog3",
    force: Forces.LANDMARK_DONOR_SLOT1,
    donors: ["rpcustomermain0", "rpcustomermain1", "rpcustomermain2", "rpcustomermain3"]
});

cleverapps.styles.autumn26 = {
    fogAsColorForUnits: {
        color: new cc.Color(0, 150, 255, 255),
        opacity: 120
    }
};

cleverapps.styles.autumn26.expeditionWandsGuideWindow = cleverapps.clone(cleverapps.styles.ExpeditionWandsGuideWindow, true);
cleverapps.styles.autumn26.expeditionWandsGuideWindow.secondStage = {
    container: {
        x: { align: "center" },
        y: { align: "center", dy: -80 }
    },

    ground: {
        x: 0,
        y: 0
    },

    prizeview: {
        x: { align: "center" },
        y: { align: "top", anchor: 0, dy: 80 }
    },

    hero: {
        x: 205,
        y: 190,
        scale: 1.1
    },

    finger: {
        x: 305,
        y: 33
    }
};
cleverapps.styles.autumn26.expeditionWandsGuideWindow.firstStage.container = {
    x: { align: "center" },
    y: { align: "center", dy: -80 }
};
cleverapps.styles.autumn26.expeditionWandsGuideWindow.thirdStage.container = {
    x: { align: "center" },
    y: { align: "center", dy: -80 }
};
UnitsLibrary.CODES_BY_TAB.autumn26 = [
    ["drhero", "drrubyhero"],
    ["drresource"],
    ["drfruit"],
    ["drgrowing", "drsource"],
    ["drchest"],
    ["drmagicplant", "snailfeast", "snailhouse"]
];

UnitsLibrary.EXPEDITION_PREFIXES.autumn26 = "dr";

ShopWindow.TABS.UNITS_EXPEDITION_AUTUMN26 = 28;

UnitsShop.SHOPS.autumn26 = [{
    tab: ShopWindow.TABS.UNITS_EXPEDITION_AUTUMN26,
    unit: { code: "dr2shop", stage: 0 }
}];

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_EXPEDITION_AUTUMN26] = {
    refreshTimeout: "24 hours",
    refreshPrice: 199,

    default: [{
        unit: {
            code: "drfreechest",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "drsack",
            stage: 0,
            amount: 2
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "drsack",
            stage: 2,
            amount: 1
        },
        price: 149,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            code: "drshopchest",
            stage: 0,
            amount: 1
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 10
    }, {
        unit: {
            code: "drshopchest",
            stage: 1,
            amount: 1
        },
        price: 129,
        type: Product.TYPE_HARD,
        left: 15
    }, {
        unit: {
            code: "drshopchest",
            stage: 2,
            amount: 1
        },
        price: 319,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        price: 119,
        type: Product.TYPE_HARD,
        left: 5
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 1
        },
        price: 79,
        type: Product.TYPE_HARD,
        left: 5
    }],

    line_template: [{
        unit: {
            stage: 0,
            amount: 1
        },
        codes: "field",
        left: 1,
        price: 199,
        type: Product.TYPE_HARD
    }]
};

PixelsPlanner.AVAILABLE.autumn26 = {
    fog: "fog3"
};

PixelsSwarm.AUTUMN26 = "autumn26";

PixelsSwarmConfig[PixelsSwarm.AUTUMN26] = {
    pages: ["autumn26"],
    reward: [{
        units: [
            { code: "drmagicplant", stage: 0 },
            { code: "worker", stage: 0 },
            { code: "drfruit", stage: 0 }
        ]
    }]
};
cleverapps.styles.PixelView[PixelsSwarm.AUTUMN26] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {
    collect: {
        x: { align: "center", dx: 10 },
        y: { align: "center", dy: -195 },
        delay: 1350
    }
}, true);

cleverapps.styles.FogTileView["autumn26"] = cleverapps.styles.FogTileView["adventure"];